export default __webpack_public_path__ + "static/media/certificatesBox.2ac887ad.png";